'use client';

import { motion } from 'framer-motion';

import type { ReactNode } from 'react';

import { useAnimationState } from '~/hooks/useAnimationState';

interface PageTransitionProps {
  children: ReactNode;
}

const variants = {
  hidden: {
    opacity: 0,
    scale: 0.97,
    y: 10,
  },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    scale: 1.03,
    y: -10,
  },
};

export function PageTransition({ children }: PageTransitionProps) {
  const animationState = useAnimationState();

  return (
    <motion.div
      initial='hidden'
      animate='visible'
      exit='exit'
      variants={variants}
      transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30,
        mass: 1.2,
        velocity: 0,
      }}
      className='w-full'
      data-animation-state={animationState}
    >
      {children}
    </motion.div>
  );
}
